import { useDefaultSavingsGoalsRoute } from '@unistocks/features/savings-goals/use-route';
import { Redirect } from 'expo-router';

export default function SavingsGoalsScreen() {
  const href = useDefaultSavingsGoalsRoute();

  return <Redirect withAnchor href={href} />;
}
